module.exports = __webpack_public_path__ + "img/commercial-paper-none.bb17af15.svg";